import React from "react";
import "../MissionandVision.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { NavLink } from "react-router-dom";

import {
    FiHome,
    FiChevronRight,
} from "react-icons/fi";

const MissionVision = () => {

    return (

        <>

            <Header />

            {/* =====================================================
                        HERO SECTION
            ===================================================== */}

            <section className="mv-hero">

                <div className="mv-overlay"></div>

                <div className="container">

                    <div className="mv-hero-content">

                        <span className="mv-tag">
                            Mission • Vision • Values
                        </span>

                        <h1>
                            Our <span>Mission & Vision</span>
                        </h1>

                        <p>
                            At Kishancart Digital (OPC) Private Limited, our
                            purpose is to empower businesses with innovative,
                            secure, and scalable technology solutions. We are
                            committed to helping startups, retailers,
                            enterprises, and agricultural businesses embrace
                            digital transformation and achieve sustainable
                            growth through modern software, e-commerce
                            platforms, and business automation.
                        </p>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        BREADCRUMB
            ===================================================== */}

            <section className="mv-breadcrumb">

                <div className="container">

                    <div className="breadcrumb">

                        <NavLink to="/">
                            <FiHome />
                            Home
                        </NavLink>

                        <FiChevronRight />

                        <span>Company</span>

                        <FiChevronRight />

                        <span className="active">
                            Mission & Vision
                        </span>

                    </div>

                </div>

            </section>

            {/* =====================================================
                    NEXT PART STARTS HERE
                    Mission + Vision
            ===================================================== */}

            {/* =====================================================
                        MISSION & VISION
            ===================================================== */}

            <section className="mission-vision">

                <div className="container">

                    <div className="mv-grid">

                        {/* ================= Mission ================= */}

                        <div className="mv-card">

                            <span className="section-tag">
                                Our Mission
                            </span>

                            <h2>
                                Empowering Businesses Through
                                <span> Technology</span>
                            </h2>

                            <p>
                                Our mission is to help startups, retailers,
                                enterprises, manufacturers, and agricultural
                                businesses accelerate their digital
                                transformation by delivering innovative,
                                secure, and scalable technology solutions that
                                improve efficiency, customer experience, and
                                long-term business growth.
                            </p>

                            <p>
                                We focus on developing high-quality
                                e-commerce platforms, marketplace solutions,
                                business websites, ERP systems, mobile
                                applications, and customized software that
                                simplify business operations while creating
                                measurable value for our clients.
                            </p>

                            <div className="mv-list">

                                <div className="mv-item">
                                    <span>✓</span>
                                    <p>Deliver secure and scalable software solutions.</p>
                                </div>

                                <div className="mv-item">
                                    <span>✓</span>
                                    <p>Support digital transformation for every business.</p>
                                </div>

                                <div className="mv-item">
                                    <span>✓</span>
                                    <p>Develop innovative e-commerce and marketplace platforms.</p>
                                </div>

                                <div className="mv-item">
                                    <span>✓</span>
                                    <p>Build long-term partnerships through quality and trust.</p>
                                </div>

                            </div>

                        </div>

                        {/* ================= Vision ================= */}

                        <div className="mv-card">

                            <span className="section-tag">
                                Our Vision
                            </span>

                            <h2>
                                Building a
                                <span> Digital Future</span>
                            </h2>

                            <p>
                                Our vision is to become one of India's most
                                trusted technology companies by delivering
                                world-class digital commerce, enterprise
                                software, cloud solutions, and innovative
                                business platforms that empower organizations
                                across industries.
                            </p>

                            <p>
                                We aspire to create technology that connects
                                businesses, customers, and opportunities while
                                driving sustainable growth, innovation, and
                                operational excellence through modern digital
                                solutions.
                            </p>

                            <div className="mv-list">

                                <div className="mv-item">
                                    <span>✓</span>
                                    <p>Lead innovation in digital commerce solutions.</p>
                                </div>

                                <div className="mv-item">
                                    <span>✓</span>
                                    <p>Enable businesses with AI-ready and cloud technologies.</p>
                                </div>

                                <div className="mv-item">
                                    <span>✓</span>
                                    <p>Create scalable platforms for future business growth.</p>
                                </div>

                                <div className="mv-item">
                                    <span>✓</span>
                                    <p>Become a trusted technology partner worldwide.</p>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                    NEXT PART STARTS HERE
                    Core Values + Business Goals
            ===================================================== */}

            {/* =====================================================
                        OUR CORE VALUES
            ===================================================== */}

            <section className="core-values">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Our Core Values
                        </span>

                        <h2>
                            Principles That Guide
                            <span> Everything We Do</span>
                        </h2>

                        <p>
                            At Kishancart Digital, our values shape every
                            decision, every solution, and every client
                            relationship. They define who we are and inspire
                            us to deliver technology that creates lasting
                            business value.
                        </p>

                    </div>

                    <div className="values-grid">

                        <div className="value-card">

                            <h3>Innovation</h3>

                            <p>
                                We embrace modern technologies and creative
                                thinking to build future-ready digital
                                solutions.
                            </p>

                        </div>

                        <div className="value-card">

                            <h3>Integrity</h3>

                            <p>
                                Honesty, transparency, and ethical business
                                practices are the foundation of every client
                                partnership.
                            </p>

                        </div>

                        <div className="value-card">

                            <h3>Customer Success</h3>

                            <p>
                                Our clients' growth and long-term success
                                remain at the center of everything we build.
                            </p>

                        </div>

                        <div className="value-card">

                            <h3>Excellence</h3>

                            <p>
                                We deliver reliable, secure, and high-quality
                                software solutions with attention to every
                                detail.
                            </p>

                        </div>

                        <div className="value-card">

                            <h3>Collaboration</h3>

                            <p>
                                Strong communication and teamwork help us
                                create solutions that truly meet business
                                objectives.
                            </p>

                        </div>

                        <div className="value-card">

                            <h3>Continuous Learning</h3>

                            <p>
                                We continuously improve our knowledge,
                                processes, and technologies to stay ahead in
                                the digital world.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        BUSINESS GOALS
            ===================================================== */}

            <section className="business-goals">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Business Goals
                        </span>

                        <h2>
                            Driving Sustainable
                            <span> Digital Growth</span>
                        </h2>

                        <p>
                            Our strategic goals focus on helping businesses
                            innovate, automate operations, strengthen customer
                            engagement, and achieve long-term success through
                            reliable technology solutions.
                        </p>

                    </div>

                    <div className="goals-grid">

                        <div className="goal-card">

                            <h3>Digital Transformation</h3>

                            <p>
                                Enable businesses to modernize operations with
                                scalable digital platforms and enterprise
                                software.
                            </p>

                        </div>

                        <div className="goal-card">

                            <h3>Business Automation</h3>

                            <p>
                                Simplify workflows through ERP systems,
                                inventory management, and customized software
                                solutions.
                            </p>

                        </div>

                        <div className="goal-card">

                            <h3>Customer Experience</h3>

                            <p>
                                Build intuitive websites, e-commerce
                                platforms, and mobile applications that
                                enhance customer satisfaction.
                            </p>

                        </div>

                        <div className="goal-card">

                            <h3>Sustainable Growth</h3>

                            <p>
                                Deliver secure and future-ready technology
                                that supports continuous innovation and
                                long-term business success.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                    NEXT PART STARTS HERE
                    What We Believe + Our Commitment + Footer
            ===================================================== */}

            {/* =====================================================
                        WHAT WE BELIEVE
            ===================================================== */}

            <section className="belief-section">

                <div className="container">

                    <div className="belief-grid">

                        {/* Left */}

                        <div className="belief-card">

                            <span className="section-tag">
                                What We Believe
                            </span>

                            <h2>
                                Technology Should Empower
                                <span> Every Business</span>
                            </h2>

                            <p>
                                At Kishancart Digital (OPC) Private Limited,
                                we believe technology should simplify business,
                                improve productivity, and create opportunities
                                for sustainable growth. Every organization,
                                whether a startup, retailer, manufacturer,
                                agricultural enterprise, or large corporation,
                                deserves reliable digital solutions that help
                                them compete confidently in today's digital
                                economy.
                            </p>

                            <p>
                                We are committed to building solutions that
                                are secure, scalable, user-friendly, and
                                designed to solve real business challenges
                                while delivering measurable value.
                            </p>

                        </div>

                        {/* Right */}

                        <div className="belief-card">

                            <span className="section-tag">
                                Our Promise
                            </span>

                            <h2>
                                A Trusted
                                <span> Technology Partner</span>
                            </h2>

                            <p>
                                We promise to deliver high-quality software,
                                transparent communication, dependable support,
                                and innovative technology tailored to each
                                client's business goals.
                            </p>

                            <p>
                                Our team continuously invests in modern
                                development practices, emerging technologies,
                                and customer-focused innovation to ensure that
                                every project contributes to long-term
                                business success.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        OUR COMMITMENT
            ===================================================== */}

            <section className="commitment-section">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Our Commitment
                        </span>

                        <h2>
                            Dedicated To
                            <span> Excellence</span>
                        </h2>

                        <p>
                            Our commitment extends beyond software development.
                            We build long-term relationships by delivering
                            reliable technology, exceptional service, and
                            continuous innovation that helps businesses grow
                            with confidence.
                        </p>

                    </div>

                    <div className="commitment-grid">

                        <div className="commitment-card">

                            <h3>Quality Assurance</h3>

                            <p>
                                Every project undergoes rigorous testing to
                                ensure reliability, security, and outstanding
                                performance.
                            </p>

                        </div>

                        <div className="commitment-card">

                            <h3>Secure Development</h3>

                            <p>
                                We follow modern development standards and
                                best practices to build safe, scalable, and
                                future-ready digital solutions.
                            </p>

                        </div>

                        <div className="commitment-card">

                            <h3>Long-Term Support</h3>

                            <p>
                                Our partnership continues after deployment
                                with ongoing maintenance, updates, and
                                technical assistance.
                            </p>

                        </div>

                        <div className="commitment-card">

                            <h3>Continuous Innovation</h3>

                            <p>
                                We continuously improve our products and
                                services by embracing emerging technologies
                                and evolving business needs.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            <Footer />

        </>

    );

};

export default MissionVision;